import Layout from 'src/components/Layout';
import Navbar from 'src/components/NavBar';
import VarianceMain from 'src/sections/variance/VarianceMain';

const Variances = () => (
  <div>
    <Navbar title="Variances" />
    <Layout>
      <VarianceMain />
    </Layout>
  </div>
);

export default Variances;
